import { useSelector } from "react-redux";

const Status = ({ updateModalState, modalData }) => {
  const { user } = useSelector((state) => state.user);

  const confirmedStatusList = [
    { status: "unviewed", label: "Gözləmədə" },
    { status: "confirmed", label: "Keçirilib" },
    { status: "cancelled", label: "Əvəzlənəcək" },
  ];

  const handleStatusClick = (status) => {
    if (
      (user?.role === "teacher" || user?.role === "mentor") &&
      status === "cancelled"
    )
      return;

    if (
      user?.role !== "teacher" &&
      user?.role !== "mentor" &&
      status !== "cancelled"
    )
      return;

    updateModalState("status", status);
  };

  return (
    <>
      <div className="modal-select">
        <ul>
          {confirmedStatusList.map((item, i) => (
            <li
              key={i}
              className={item.status === modalData?.status ? "active" : ""}
              onClick={() => handleStatusClick(item.status)}
              id={item.status}
            >
              {item.label}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Status;
